// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionsStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        clear: both;
        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};

actionsStyles.buttonsHidden = {
    css: css`
        display: flex;
    `,
};

actionsStyles.addAllToCartButton = {
    sizeVariant: "small",
    variant: "primary",
    css: css`
        margin-left: 10px;
        ${xScreen("lt", "sm")} {
            margin-left: 0;
            margin-top: 10px;
        }
    `,
};

actionsStyles.addToListButton = {
    variant: "secondary",
    sizeVariant: "small",
    css: css`
        margin-left: 10px;
        ${xScreen("lt", "sm")} {
            margin-left: 0;
            margin-top: 10px;
            display: block;
            width: 100%;
        }
    `,
};

actionsStyles.uploadOrderButton = {
    sizeVariant: "small",
    variant: "secondary",
    css: css`
        ${xScreen("lt", "sm")} {
            display: block;
            width: 100%;
        }
    `,
};

actionsStyles.overflowMenu = {
    buttonProps: {
        css: css`
            margin-left: 2px;
        `,
    },
    cssOverrides: {
        wrapper: css`
            width: 28px;
            height: 28px;
        `,
    },
};
